import type { SessionUser } from "../../shared/types";
import { getMeta, setMeta } from "./db";

const SESSION_KEY = "local_session_user";

export async function saveLocalSession(user: SessionUser): Promise<void> {
  await setMeta(SESSION_KEY, JSON.stringify(user));
}

export async function loadLocalSession(): Promise<SessionUser | null> {
  const raw = await getMeta(SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as SessionUser;
    if (!parsed?.id || !parsed?.organisationId || !parsed?.email) return null;
    return parsed;
  } catch {
    return null;
  }
}

export async function clearLocalSession(): Promise<void> {
  await setMeta(SESSION_KEY, "");
}
